import { UserInfoInterface } from 'types/user';

export interface PrefixAchievementsLinkParams {
  loadingInfo: boolean;
  isRede: boolean;
  userInfo?: UserInfoInterface;
  tasksManager?: any;
  tasksDuplaManager?: any;
}

export interface TaskCyclesVisibilityParams extends PrefixAchievementsLinkParams {
  cycleIsClosed: boolean;
}

function hasItems(list?: any): boolean {
  return Array.isArray(list) && list.length > 0;
}

// Gestor que participa da escada de apreciação (Validação → Nível 1/2/3). O `cod_etapa`
// é o mesmo critério que TaskCycles usa para montar a seção do gestor, e por isso ele
// entra aqui: sem ele, gestores fora da escada (cod_etapa 99, sentinela da base) abririam
// a caixa do dashboard sem nenhum conteúdo dentro.
export function isAppreciationLadderManager(userInfo?: UserInfoInterface): boolean {
  return (
    !!userInfo?.is_manager &&
    typeof userInfo.cod_etapa === 'number' &&
    userInfo.cod_etapa <= 5 &&
    userInfo.tipo_de_acordo === 'HIBRIDO'
  );
}

// Decide se a seção "Realizações Destaque" (TaskCycles) aparece na home.
//
// O gate era guiado por realização: quem não tivesse nenhuma realização roteada para si
// simplesmente não via a seção. Isso escondia a área INTEIRA do gestor que ainda não
// recebeu realização alguma na fase — nem o botão de apreciar, nem o aviso de que não há
// nada pendente, que o próprio TaskCycles já sabe exibir. `isAppreciationLadderManager`
// cobre esse caso.
//
// As checagens de HIBRIDO/substituindo continuam porque não são redundantes: elas ainda
// respondem por gestores FORA da escada (cod_etapa > 5), preservando o que eles já viam.
export function shouldShowTaskCyclesSection({
  loadingInfo,
  cycleIsClosed,
  isRede,
  userInfo,
  tasksManager,
  tasksDuplaManager,
}: TaskCyclesVisibilityParams): boolean {
  if (cycleIsClosed) {
    return false;
  }

  return participatesInTaskCycles({ loadingInfo, isRede, userInfo, tasksManager, tasksDuplaManager });
}

// Decide se o bloco "Realizações do prefixo" (`PrefixAchievements`) aparece na Home. O item de
// menu que esta regra também decidia saiu (AJ3-15); a página "Ver todos" barra só o perfil Rede
// (AJ3-14), não usa esta regra.
//
// Mesma elegibilidade da seção, MENOS o ciclo fechado: a listagem do prefixo é histórica e
// continua fazendo sentido depois que o ciclo fecha — o usuário quer consultar o que a
// unidade entregou. A seção TaskCycles é que não sobrevive ao fechamento, porque a home troca
// por `TaskCyclesClosed`.
//
// Ciclos v2/v3 também passam por aqui: abrem na Home nova (CAN-01), e o bloco segue a mesma
// regra dos demais ciclos fechados.
export function shouldShowPrefixAchievementsLink(params: PrefixAchievementsLinkParams): boolean {
  return participatesInTaskCycles(params);
}

// Elegibilidade do jogador à dinâmica de Realizações Destaque, independente do ciclo.
function participatesInTaskCycles({
  loadingInfo,
  isRede,
  userInfo,
  tasksManager,
  tasksDuplaManager,
}: PrefixAchievementsLinkParams): boolean {
  if (loadingInfo || isRede || !userInfo) {
    return false;
  }

  const isHibrido = userInfo.tipo_de_acordo === 'HIBRIDO';

  return (
    (userInfo.cad_missao === 1 && isHibrido) ||
    isAppreciationLadderManager(userInfo) ||
    hasItems(tasksManager) ||
    hasItems(tasksDuplaManager) ||
    (typeof userInfo.team_hibrido === 'number' && userInfo.team_hibrido > 0) ||
    (!!userInfo.is_manager && isHibrido) ||
    (!!userInfo.is_manager && userInfo.substituindo === 'SIM' && isHibrido)
  );
}
